import React from 'react'

export const SliderSettings = props => {
  return (
    <div className="empty-message">
      <p>No options available</p>
    </div>
  )
}
